<template>
  <WhiteModal 
    :title="$t('pos_storage_leftovers_popup.title')" 
    size="sm"
    bodyClass="poster-leftovers-modal-body " 
    @close="$emit('close')">
        <div class="qrw-heading-xs bold v1-grey-10-color qrw-center">
            {{ $t('pos_storage_leftovers_popup.items_hidden', {
                count: hiddenItemsCount
            }) }}
        </div>

        <BaseDivider color="v1-grey-4" style="width: 200px"/>

        <div class="qrw-heading-xs v1-grey-10-color qrw-center">
            {{ $t('pos_storage_leftovers_popup.choose_action') }}
        </div>

      <template #footer>
          <BaseButton variant="secondary" :busy="busy" size="md" color="v1-grey-10" class="w-100" @click="$emit('close')">
            {{ $t('pos_storage_leftovers_popup.btn_hide') }}
          </BaseButton>
          <BaseButton variant="primary" :busy="busy" size="md" color="green-5" class="w-100" @click="showItems">
            {{ $t('pos_storage_leftovers_popup.btn_show') }}
          </BaseButton>
      </template>
  </WhiteModal>
</template>

<script>
import MenuAPI from '@/api/menu'

export default {
    data() {
        return {
            busy: false
        }
    },
    computed: {
        hiddenItemsCount() {
            return this.$store.state.menu.current.products.filter(p => !p.stock || p.stock_count <= 0).length;
        }
    },
    methods: {
        showItems() {
            this.busy = true;

            const promises = this.$store.state.menu.menus.map(m => MenuAPI.stockifyItems(m._id));

            Promise.all(promises).finally(() => {
                this.$store.dispatch('menu/fetchMenus');
                this.$emit('close');
            });
        }
    }
}
</script>

<style>
.poster-leftovers-modal-body {
    padding: 40px !important;
    display: flex;
    align-items: center;
    row-gap: 16px !important;
}
</style>

<style scoped>

</style>